import MiddleInfoMessage from './MiddleInfoMessage';

export default MiddleInfoMessage;
